/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "12.1.0";
